/**
 * @generated SignedSource<<b10cb10923e0ff292251c80e8e5a5b12>>
 * @relayHash 9b7f0217b43d85218f27862490295b10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 01d8ed0c3283e68b7522857aec9a85c29d61d024ebcad1c9094d69f5e1675f25

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentQuery } from './PopupContentQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "01d8ed0c3283e68b7522857aec9a85c29d61d024ebcad1c9094d69f5e1675f25",
    "metadata": {},
    "name": "PopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
